import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Submit ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: _ctx.name }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        layout: "vertical",
        model: _ctx.form,
        id: "myForm",
        onFinish: _ctx.handleSaving
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: [24, 5] }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 8 },
                lg: { span: 8 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "First Name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        id: "first_name",
                        value: _ctx.form.first_name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.first_name) = $event)),
                        placeholder: "Juan"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 8 },
                lg: { span: 8 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "Middle Name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        id: "middle_name",
                        value: _ctx.form.middle_name,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.middle_name) = $event)),
                        placeholder: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 8 },
                lg: { span: 8 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "Last Name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        id: "last_name",
                        value: _ctx.form.last_name,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.last_name) = $event)),
                        placeholder: "Dela Cruz"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: [24, 5] }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 12 },
                lg: { span: 12 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "Email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        id: "email",
                        type: "email",
                        value: _ctx.form.email,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event)),
                        placeholder: "user@app.com"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "Password" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        id: "password",
                        type: "password",
                        value: _ctx.form.password,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password) = $event)),
                        placeholder: "password"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "Confirm Password" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        id: "password_confirmation",
                        type: "password",
                        value: _ctx.form.password_confirmation,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.password_confirmation) = $event)),
                        placeholder: "password"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                sm: { span: 24 },
                md: { span: 12 },
                lg: { span: 12 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "Employee ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        id: "employee_number",
                        value: _ctx.form.employee_number,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.employee_number) = $event)),
                        placeholder: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "Business Unit" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        id: "business_unit_id",
                        value: _ctx.form.business_unit_id,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.business_unit_id) = $event)),
                        filterOption: "filterOption",
                        optionFilterProp: "children",
                        "show-search": ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.business_units, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              ref_for: true,
                              ref: "business_units",
                              value: item.id,
                              key: item.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, {
            justify: "end",
            gutter: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { onClick: _ctx.back }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    key: "submit",
                    type: "primary",
                    htmlType: "submit",
                    loading: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "onFinish"])
    ]),
    _: 1
  }, 8, ["title"]))
}